export default __webpack_public_path__ + "static/media/avatar.2278d90d.jpg";